var service = {
    API_URL: process.env.REACT_APP_API_URL,
    // API_URL: "http://localhost:5050"
};
export default service; 
